<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15uV3GK/tc-custom/9781035801855.jpg?1723231593282" alt="This image is the cover for the book Poetry from the Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poetry from the Heart
      </h1>
      <p class="bookDescription body article font2">
        <p>Experiences. Emotions. Told through poems that speak more than their words. Based on personal experiences, experiences of others and those more universally experienced. A home within the words. Lives within the pages. Have you ever had an experience that you couldn’t just quite describe: to be so full of emotion that you couldn’t verbalise exactly how you’re feeling? Flip through these pages and discover the words that you were missing. Written from those same raw, human experiences and emotions. For any and all to enjoy. A range of poems from personal and everyday troubles to topics dealing with society and governance. Delve into the realms of romance and friendships, or perhaps under a tree with nature; join us on the true adventures of the life within. Whatever your preferences, there’ll be a poem in here, waiting for you to discover it. All you need to do is sit back and read.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Campbell-Brown
      </h2>
      
      <p class="authorDescription body article">Alexander took inspiration from the poetry he learned in A level English. Following Carol Ann Duffy’s lead, he decided to try it out for himself, and his love for the art flourished more. His main goal for his poetry is for other people to feel heard and to give voices to those who would otherwise be silent. Using his passion and classes in philosophy to deepen his meanings to his poetry, Alexander intends to continue down this road in the future.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a9019f6